import { configureStore } from '@reduxjs/toolkit'
import appStateSlice from './features/appStateSlice'

export const store = configureStore({
  reducer: {
    appState: appStateSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
